var map = {
	"./dashboard.svg": 7532,
	"./example.svg": 978,
	"./eye-open.svg": 5160,
	"./eye.svg": 7591,
	"./form.svg": 7610,
	"./link.svg": 2936,
	"./nested.svg": 2705,
	"./password.svg": 731,
	"./table.svg": 9212,
	"./tree.svg": 1024,
	"./user.svg": 681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;